var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageCornerGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.440185 16.6158C4.71926 17.2741 8.94349 14.9178 10.315 13.4092C8.90135 10.0382 17.6289 1.85069 11.8686 1.85037C10.5366 1.85037 9.39897 -1.63879 4.55468 0.98067C4.53723 2.03961 4.55468 5.70511 4.55468 6.32919C4.55468 14.9696 -0.382716 16.1193 0.440185 16.6158Z",
    fill: "#E9E9EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCornerGrey);
export default __webpack_public_path__ + "static/media/message-corner-grey.3acf8685b5895bf3018acb8b156f7cca.svg";
export { ForwardRef as ReactComponent };